import React from "react";

export default function ManagePrestasi() {
  return (
    <div className="container mt-5">
      <h2>Kelola Prestasi</h2>
      <p>
        Halaman ini digunakan untuk menambahkan, mengubah, dan menghapus data
        prestasi siswa maupun sekolah.
      </p>
      <div className="alert alert-info mt-4">
        ✨ Fitur ini masih dalam pengembangan.
      </div>
    </div>
  );
}
